/**
 * Masthead flavor text — a running joke on the app's own initialism ("eFss" reads like the
 * plural of the letter the "no f's to give" line is actually saying), picked once per mount
 * by `App.tsx` so it doesn't jump around underneath a page transition.
 */
export const TAGLINES: string[] = [
  "Do you have any eFss to give?",
  "I'm all out of eFss.",
  "What the eFss am I supposed to do first?",
  "Not one eFss left today - start small.",
  "Save a few eFss for tomorrow.",
  "eFss given: zero. Let's fix that.",
  "This app runs entirely on eFss.",
  "Your daily supply of eFss, restocked.",
  "Give an eFss. Just one.",
  "Pick a few eFss to give today.",
  "Warning: eFss levels critically low.",
  "Some days you just don't have the eFss.",
  "eFss: now in stock.",
  "No eFss detected. Try again tomorrow.",
  "An eFss a day keeps procrastination away.",
  "Batteries not included. eFss sold separately.",
  "Currently accepting donations of eFss.",
  "Insert eFss to continue.",
  "This is a judgment-free zone for low-eFss days.",
  "Terms and conditions apply to all eFss given.",
];

export function randomTagline(): string {
  return TAGLINES[Math.floor(Math.random() * TAGLINES.length)];
}
